<template>
    <div class="page-gallery">
        <nav class="toolbar">
            <b-container fluid>
                <b-row>
                    <b-col xs="12" sm="9" md="8" lg="6" class="py-2">
                        <a href role="button"><i class="fa fa-star"></i> TOP PICKS</a>
                        <a href role="button" @click.prevent v-b-toggle.gallery-filter-collapse>
                            <i class="fa fa-th"></i>
                            FILTER
                            <i class="fa fa-caret-down"></i>
                        </a>
                        <router-link to="/favorites">
                            <i class="fa fa-heart"></i>
                            FAVORITES
                        </router-link>
                        <a href role="button">ABOUT</a>
                        <div class="clearfix"></div>
                    </b-col>
                    <b-col class="text-right" xs="12" sm="3" md="4" lg="6">
                        <label for="search-input" class="hidden" style="display: none;">SEARCH</label>
                        <input type="text" class="form-control form-control-sm" id="search-input" placeholder="Search" @keyup="search" v-model="searchInput">
                    </b-col>
                </b-row>
            </b-container>
        </nav>


        <b-collapse class="gallery-filters-collapse" id="gallery-filter-collapse">
            <button class="filter-dropdown-button btn btn-primary" href role="button" @click.prevent="toggleCollapse('types')">
                TYPE <i class="fa fa-caret-down"></i>
            </button>
            <button class="filter-dropdown-button btn btn-primary" href role="button" @click.prevent="toggleCollapse('brands')">
                BRANDS <i class="fa fa-caret-down"></i>
            </button>
            <button class="filter-dropdown-button btn btn-primary" href role="button" @click.prevent="toggleCollapse('relevance')">
                RELEVANCE <i class="fa fa-caret-down"></i>
            </button>
            <button v-if="$store.state.locations.length" class="filter-dropdown-button btn btn-primary" href role="button" @click.prevent="toggleCollapse('locations')">
                LOCATIONS <i class="fa fa-caret-down"></i>
            </button>

            <div v-if="whichCollapse === 'types'" class="gallery-filters-dropdown py-3">
                <b-container fluid class="py-3">
                    <b-row>
                        <b-col cols="12" sm="4">
                            <p>ACOUSTIC PIANOS</p>

                            <hr style="border: 1px solid #fff;margin-right: -100px;margin-left: -100px">

                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Grand" v-model="filters.types" @click="toggleFinishes()">
                                    Grand Pianos
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Upright" v-model="filters.types" @click="toggleFinishes()">
                                    Upright Pianos
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Player" v-model="filters.types" @click="toggleFinishes()">
                                    Player Pianos
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Technology" v-model="filters.types" @click="toggleFinishes()">
                                    Technology Based
                                </label>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="4">
                            <p>DIGITAL PIANOS</p>

                            <hr style="border: 1px solid #fff;margin-right: -100px;margin-left: -100px">

                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Traditional" v-model="filters.types">
                                    Traditional
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Ensemble" v-model="filters.types">
                                    Ensemble
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Portables" v-model="filters.types">
                                    Portables
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Hybrid" v-model="filters.types">
                                    Hybrid
                                </label>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="4" v-if="hasOtherTypesOfPianos">
                            <p>OTHER KEYBOARDS</p>

                            <hr style="border: 1px solid #fff;margin-right: -100px;margin-left: -100px">

                            <div class="form-check" v-if="$store.state.pianos.filter(p => p.type === 'Portable').length > 0">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Portable" v-model="filters.types">
                                    Portable
                                </label>
                            </div>
                            <div class="form-check" v-if="$store.state.pianos.filter(p => p.type === 'Organs').length > 0">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Organs" v-model="filters.types">
                                    Organs
                                </label>
                            </div>
                            <div class="form-check" v-if="$store.state.pianos.filter(p => p.type === 'Harsichords').length > 0">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Harsichords" v-model="filters.types">
                                    Harsichords
                                </label>
                            </div>
                            <div class="form-check" v-if="$store.state.pianos.filter(p => p.type === 'Synth').length > 0">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" value="Synth" v-model="filters.types">
                                    Synth
                                </label>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>


            <b-collapse id="finishes-collapse" v-model="showFinishes" class="py-3">
                <b-container fluid>
                    <p class="mb-0">FINISHES</p>
                    <hr class="my-2" style="border: 1px solid #928762">

                    <b-row>
                        <b-col cols="4" v-for="finish in finishes" :key="finish" v-if="showFinish(finish)">
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" :value="finish" v-model="filters.finishes">
                                    {{ finish }}
                                </label>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </b-collapse>


            <div v-if="whichCollapse === 'brands'" class="gallery-filters-dropdown py-3">
                <b-container fluid>
                    <b-row>
                        <b-col cols="12" sm="6" md="4" v-for="brand in brands" :key="brand.name">
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input class="form-check-input" type="checkbox" :value="brand.name" v-model="filters.brands">
                                    {{ brand.name }}
                                    ({{ brand.count }})
                                </label>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>


            <div v-if="whichCollapse === 'relevance'" class="gallery-filters-dropdown py-3">
                <b-container fluid>
                    <div class="form-radio">
                        <label class="form-radio-label">
                            <input class="form-radio-input" type="radio" value="latest" v-model="sort">
                            Most Recent
                        </label>
                    </div>
                    <div class="form-radio">
                        <label class="form-radio-label">
                            <input class="form-radio-input" type="radio" value="oldest" v-model="sort">
                            Oldest
                        </label>
                    </div>
                    <div class="form-radio">
                        <label class="form-radio-label">
                            <input class="form-radio-input" type="radio" value="price-high-low" v-model="sort">
                            Highest to Lowest
                        </label>
                    </div>
                    <div class="form-radio">
                        <label class="form-radio-label">
                            <input class="form-radio-input" type="radio" value="price-low-high" v-model="sort">
                            Lowest to Highest
                        </label>
                    </div>
                    <div class="form-radio">
                        <label class="form-radio-label">
                            <input class="form-radio-input" type="radio" value="close-out" v-model="sort">
                            Close Outs
                        </label>
                    </div>
                </b-container>
            </div>


            <div v-if="$store.state.locations.length && whichCollapse === 'locations'" class="gallery-filters-dropdown py-3">
                <b-container fluid>
                    <label class="d-inline-block mr-3 align-top">
                        <input type="radio" v-model="filters.location" :value="null">
                        All locations
                    </label>

                    <label v-for="location in locations" class="d-inline-block px-3 align-top">
                        <input type="radio" v-model="filters.location" :value="location.id">
                        {{ location.name }}<br>
                        {{ `${location.address} ${location.address2}` }}<br>
                        {{ `${location.city}, ${location.state} ${location.zip}` }}<br>
                    </label>

                    <div class="clearfix"></div>
                </b-container>
            </div>
        </b-collapse>

        <main>
            <b-container fluid>
                <b-row v-if="pianos.length">
                    <b-col xs="12" sm="6" md="4" lg="3"
                           v-for="piano in pianos"
                           :key="piano.id"
                           class="piano-container mb-3">
                        <router-link :to="'/pianos/'+piano.id" class="piano-link">
                            <div class="piano-image">
                                <div class="piano-image-inner" :style="{backgroundImage: 'url(\'' + piano.thumbnail + '\')'}">
                                    <h3 v-if="piano.sold" class="piano-sold-tag text-center mb-0">SOLD</h3>
                                </div>
                            </div>

                            <div class="piano-info p-2">
                                <b-container>
                                    <b-row>
                                        <b-col cols="10" class="text-center">
                                            <b-row>
                                                <b-col class="p-1 pb-2 piano-manufacturer-container text-truncate">{{ piano.manufacturer }}</b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="6" class="p-1 pt-2 text-truncate piano-name-container">{{ piano.model || piano.name }}</b-col>
                                                <b-col cols="6" class="p-1 pt-2 text-truncate piano-price-container">
                                                    {{ !isNaN(parseInt(piano.price)) && piano.price.indexOf('$') === -1 ? '$' : '' }}{{ piano.price || 'Contact Us' }}
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="2" class="p-0 text-center info-button-container">
                                            <span class="info-button">i</span>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </div>
                        </router-link>
                    </b-col>
                </b-row>
                <b-row v-if="!pianos.length">
                    <b-col>
                        <h3 class="text-center mt-5">No pianos found.</h3>
                    </b-col>
                </b-row>
            </b-container>
        </main>
    </div>
</template>

<script>
export default {
    name: 'Gallery',
    data() {
        return {
            whichCollapse: null,
            allPianos: this.$store.state.pianos,
            locations: this.$store.state.locations,
            types: this.$store.state.types,
            brands: this.$store.state.pianos
                .map(p => {
                    return {
                        name: p.manufacturer || '',
                    }
                })
                .filter(({name}, index, self) => self.findIndex(s => s.name === name) === index)
                .map(p => {
                    p.count = this.$store.state.pianos.filter(p2 => p2.manufacturer.toLowerCase() === p.name.toLowerCase()).length

                    return p
                })
                .sort((a, b) => {
                    if (a < b) {
                        return -1
                    }

                    if (a > b) {
                        return 1
                    }

                    return 0
                }),
            finishes: this.$store.state.finishes,
            searchInput: null,
            showFinishes: false,
            sort: null,
            filters: {
                types: [],
                brands: [],
                finishes: [],
                location: null,
            },
        }
    },


    methods: {
        search() {
            this.filters = {
                types: [],
                brands: [],
                finishes: [],
                location: null,
            }
        },


        toggleCollapse(selected) {
            if (this.whichCollapse === selected) {
                this.whichCollapse = null
            }
            else {
                this.whichCollapse = selected
            }

            if (this.whichCollapse !== 'types') {
                this.showFinishes = false
            }
        },


        pianosWithFilterExists(property, value) {
            return this.pianos.filter((piano) => {
                return piano[property] === value
            }).length
        },


        showFinish(finish) {
            return this.allPianos
                .filter((piano) => {
                    return this.filters.types.includes(piano.type)
                })
                .filter((piano) => {
                    return piano.finish && finish && piano.finish.toLowerCase() === finish.toLowerCase()
                }).length > 0
        },


        /**
         * If any of the acoustic filters is checked, show the finishes.
         */
        toggleFinishes() {
            setTimeout(() => {
                const regex = new RegExp('Grand|Upright|Player|Technology', 'i')
                const showFinishes = !!this.filters.types.join().match(regex)
                this.showFinishes = showFinishes

                if (!showFinishes) {
                    this.filters.finishes = []
                }
            }, 100)
        },


        sortPianos(pianos) {
            switch (this.sort) {
                case 'oldest':
                    pianos = pianos.sort((a, b) => {
                        const aSplit = a.created_at.split(/-|:| /)
                        const bSplit = b.created_at.split(/-|:| /)
                        const aDate = new Date(aSplit[0], aSplit[1] - 1, aSplit[2], aSplit[3], aSplit[4], aSplit[5])
                        const bDate = new Date(bSplit[0], bSplit[1] - 1, bSplit[2], bSplit[3], bSplit[4], bSplit[5])

                        return aDate - bDate
                    })
                    break
                case 'latest':
                    pianos = pianos.sort((a, b) => {
                        const aSplit = a.created_at.split(/-|:| /)
                        const bSplit = b.created_at.split(/-|:| /)
                        const aDate = new Date(aSplit[0], aSplit[1] - 1, aSplit[2], aSplit[3], aSplit[4], aSplit[5])
                        const bDate = new Date(bSplit[0], bSplit[1] - 1, bSplit[2], bSplit[3], bSplit[4], bSplit[5])

                        return bDate - aDate
                    })
                    break
                case 'price-high-low':
                    pianos = pianos.filter((piano) => {
                        if (!piano.price || piano.price.match(/[a-z]/i)) {
                            return false
                        }

                        return true
                    }).sort((a, b) => {
                        const priceA = parseInt(a.price.replace(/^\D+/g, ''))
                        const priceB = parseInt(b.price.replace(/^\D+/g, ''))

                        return priceB - priceA
                    })
                    break
                case 'price-low-high':
                    pianos = pianos.filter((piano) => {
                        if (!piano.price || piano.price.match(/[a-z]/i)) {
                            return false
                        }

                        return true
                    }).sort((a, b) => {
                        const priceA = parseInt(a.price.replace(/^\D+/g, ''))
                        const priceB = parseInt(b.price.replace(/^\D+/g, ''))

                        return priceA - priceB
                    })
                    break
                case 'closeouts':
                    break
                default:
                    break
            }

            return pianos
        },


        log(...args) {
            console.log(...args)
        },
    },

    computed: {
        pianos() {
            const filteredPianos = []

            if (this.searchInput) {
                const input = this.searchInput.toLowerCase()

                this.$store.state.pianos.forEach((piano) => {
                    if (piano.name.toLowerCase().indexOf(input) > -1) {
                        filteredPianos.push(piano)
                    }
                    else if (piano.manufacturer.toLowerCase().indexOf(input) > -1) {
                        filteredPianos.push(piano)
                    }
                    else if (piano.description.toLowerCase().indexOf(input) > -1) {
                        filteredPianos.push(piano)
                    }
                })
            }
            else {
                let returnAll = true

                for (let key in this.filters) {
                    if (this.filters[key] === null) {
                        continue
                    }

                    if (this.filters[key].length > 0) {
                        returnAll = false
                        break
                    }
                }

                if (this.filters.location) {
                    returnAll = false
                }

                if (this.sort !== null) {
                    returnAll = false
                }

                if (returnAll) {
                    return this.$store.state.pianos
                }

                this.$store.state.pianos.forEach((piano) => {
                    // if there are no selected filters, set to true as default
                    // there is probably a better way to do this.
                    let typesMatch = this.filters.types.length === 0
                    let brandsMatch = this.filters.brands.length === 0
                    let finishesMatch = this.filters.finishes.length === 0
                    let locationsMatch

                    for (let i = 0; i < this.filters.types.length; i++) {
                        if (piano.type.toLowerCase().indexOf(this.filters.types[i].toLowerCase()) > -1) {
                            typesMatch = true
                            break
                        }
                    }

                    for (let i = 0; i < this.filters.brands.length; i++) {
                        if (piano.manufacturer.toLowerCase().indexOf(this.filters.brands[i].toLowerCase()) > -1) {
                            brandsMatch = true
                            break
                        }
                    }

                    for (let i = 0; i < this.filters.finishes.length; i++) {
                        if ((piano.finish || '').toLowerCase().indexOf(this.filters.finishes[i].toLowerCase()) > -1) {
                            finishesMatch = true
                            break
                        }
                    }

                    if (this.filters.location === null) {
                        locationsMatch = true
                    }
                    else {
                        locationsMatch = piano.location_id === this.filters.location
                    }

                    if (typesMatch && brandsMatch && finishesMatch && locationsMatch) {
                        filteredPianos.push(piano)
                    }
                })
            }

            switch (this.sort) {
                case 'latest':
                    return filteredPianos.sort((a, b) => {
                        const aSplit = a.created_at.split(/-|:| /)
                        const bSplit = b.created_at.split(/-|:| /)
                        const aDate = new Date(aSplit[0], aSplit[1] - 1, aSplit[2], aSplit[3], aSplit[4], aSplit[5])
                        const bDate = new Date(bSplit[0], bSplit[1] - 1, bSplit[2], bSplit[3], bSplit[4], bSplit[5])

                        return aDate - bDate
                    })
                case 'oldest':
                    return filteredPianos.sort((a, b) => {
                        const aSplit = a.created_at.split(/-|:| /)
                        const bSplit = b.created_at.split(/-|:| /)
                        const aDate = new Date(aSplit[0], aSplit[1] - 1, aSplit[2], aSplit[3], aSplit[4], aSplit[5])
                        const bDate = new Date(bSplit[0], bSplit[1] - 1, bSplit[2], bSplit[3], bSplit[4], bSplit[5])

                        return bDate - aDate
                    })
                case 'price-high-low':
                    return filteredPianos.sort((a, b) => {
                        if (!(a.price && b.price && parseInt(a.price.replace(/^\D+/g, '')) && parseInt(b.price.replace(/^\D+/g, '')))) {
                            return -1
                        }

                        const priceA = parseInt(a.price.replace(/^\D+/g, ''))
                        const priceB = parseInt(b.price.replace(/^\D+/g, ''))

                        return priceB - priceA
                    })
                case 'price-low-high':
                    return filteredPianos.sort((a, b) => {
                        if (!(a.price && b.price && parseInt(a.price.replace(/^\D+/g, '')) && parseInt(b.price.replace(/^\D+/g, '')))) {
                            return 1
                        }

                        const priceA = parseInt(a.price.replace(/^\D+/g, ''))
                        const priceB = parseInt(b.price.replace(/^\D+/g, ''))

                        return priceA - priceB
                    })
                case 'closeouts':
                    break
                default:
                    break
            }

            return filteredPianos
        },


        showDigitalPianoFilters() {
            return this.pianosWithFilterExists('type', 'Portables KB')
                || this.pianosWithFilterExists('type', 'Synth + Pro KB')
                || this.pianosWithFilterExists('type', 'Ensemble')
                || this.pianosWithFilterExists('type', 'Portables')
        },


        hasOtherTypesOfPianos() {
            const otherTypes = [
                'Portable',
                'Organs',
                'Harsichords',
                'Synth',
            ]

            return this.$store.state.pianos.filter(piano => {
                for (let i = 0; i < otherTypes.length; i++) {
                    if (piano.type === otherTypes[i]) {
                        return true
                    }
                }

                return false
            }).length > 0
        },
    },

    watch: {
        //
    },
}
</script>

<style type="text/scss" lang="scss">
/*there is an issue with the style loader so we can't include the styles here, go to styes/_pages.scss instead*/
</style>



// WEBPACK FOOTER //
// src/pages/Gallery.vue